import { parse, format, subDays, isBefore } from 'date-fns';

import { isSSR } from './ssr';

class ViewedHotels {
  static KEY = 'viewed_hotels';

  static FORMAT = 'ddMMyy';

  static CAPACITY_DAYS = 3;

  static get todayKey() {
    return format(new Date(), ViewedHotels.FORMAT);
  }

  static get viewed() {
    const data = localStorage.getItem(ViewedHotels.KEY);
    return data ? JSON.parse(data) : {};
  }

  static set viewed(data) {
    const { KEY } = ViewedHotels;
    localStorage.setItem(KEY, JSON.stringify(data));
  }

  static setViewed(hotelId) {
    const { viewed, todayKey } = ViewedHotels;
    viewed[todayKey] = viewed[todayKey] || {};
    viewed[todayKey][hotelId] = true;
    ViewedHotels.viewed = viewed;
  }

  static isViewed(hotelId) {
    const { viewed } = ViewedHotels;
    return Object.keys(viewed).reduce(
      (result, key) => result || viewed[key][hotelId],
    );
  }
}

function cleanStorage() {
  const { viewed } = ViewedHotels;
  const deleteAfter = subDays(new Date(), ViewedHotels.CAPACITY_DAYS);

  Object.keys(viewed).forEach((key) => {
    const keyDate = parse(key, ViewedHotels.FORMAT, new Date());
    if (isBefore(keyDate, deleteAfter)) {
      delete viewed[key];
    }
  });
  ViewedHotels.viewed = viewed;
}

if (!isSSR) {
  cleanStorage();
}

export default ViewedHotels;
